import "@/i18n/config";
import React, { useEffect, useState } from "react";

import { getComments } from "@/client_app/components/CommunityMemberDetails/services/FetchAPIService";
import { Tagger } from "@/client_app/components/CommunityMemberDetails/TabSection";
import { CommentContent } from "@/common/components/CommentContent";

interface Props {
  positionId: string;
  inAdmin?: boolean;
  taggers?: Tagger[];
}

export function AllComment(props: Props) {
  const { positionId, inAdmin, taggers } = props;

  const [typeComments, setTypeComments] = useState();
  const [globalComments, setGlobalComments] = useState({ Position: [] });

  useEffect(() => {
    if (positionId) {
      getComments({ recordId: positionId, recordType: "Position", inAdmin })
        .then((response) => response.json())
        .then((data) => {
          const { Position, ...rest } = data.comments;

          setTypeComments(rest);
          setGlobalComments({ Position });
        });
    }
  }, [positionId]);

  return (
    <div className='p-5 m-0 flex gap-8'>
      <CommentContent
        defaultComments={typeComments}
        showRecordType={true}
        recordId={positionId}
        recordType='Position'
        inAdmin={inAdmin}
        taggers={taggers}
        hideAddComment={true}
      />
      <CommentContent
        defaultComments={globalComments}
        showRecordType={true}
        recordId={positionId}
        recordType='Position'
        recordName='Position'
        inAdmin={inAdmin}
        taggers={taggers}
      />
    </div>
  );
}
